<div class="new-manager">
    <div class="main-new-manager">
        <!-- Header con título y stepper -->
        <div class="dialog-header">
            <div class="dialog-title-row">
                <h1 class="title-new-manager m-0">Nueva empresa</h1>
                <button class="btn-close-dialog" (click)="confirmClose()"><i class="fa-light fa-times"></i></button>
            </div>
            <div class="steps-indicator">
                <div class="step-item" [class.active]="currentStep === 1" [class.done]="currentStep > 1">
                    <div class="step-circle">
                        <i class="fal fa-check" *ngIf="currentStep > 1"></i>
                        <span *ngIf="currentStep <= 1">1</span>
                    </div>
                    <span class="step-label">Datos fiscales</span>
                </div>
                <div class="step-line" [class.done]="currentStep > 1"></div>
                <div class="step-item" [class.active]="currentStep === 2" [class.done]="currentStep > 2">
                    <div class="step-circle">
                        <i class="fal fa-check" *ngIf="currentStep > 2"></i>
                        <span *ngIf="currentStep <= 2">2</span>
                    </div>
                    <span class="step-label">Datos generales</span>
                </div>
                <div class="step-line" [class.done]="currentStep > 2"></div>
                <div class="step-item" [class.active]="currentStep === 3">
                    <div class="step-circle"><span>3</span></div>
                    <span class="step-label">Comisión</span>
                </div>
            </div>
        </div>

        <!-- STEP 1: Datos Fiscales -->
        <div *ngIf="currentStep === 1">
            <div *ngIf="showErrorMsg" class="info-error">
                <i class="fa-light fa-circle-exclamation"></i>
                <p class="error-msg">Completa todos los campos obligatorios antes de continuar</p>
            </div>
            <form class="form-grid" [formGroup]="companyForm">
                <div class="main-inputs">
                    <div class="field-block">
                        <label class="label-input">Razón social <span class="req">*</span></label>
                        <div class="form-input-container" [class.invalid]="companyForm.get('fiscal_name')?.invalid && companyForm.get('fiscal_name')?.touched">
                            <input type="text" class="w-100" placeholder="Ej: Mi Empresa S.L." formControlName="fiscal_name">
                        </div>
                        <span class="field-error" *ngIf="companyForm.get('fiscal_name')?.invalid && companyForm.get('fiscal_name')?.touched">Campo obligatorio</span>
                    </div>
                    <div class="field-block">
                        <label class="label-input">CIF <span class="req">*</span></label>
                        <div class="form-input-container" [class.invalid]="companyForm.get('cif')?.invalid && companyForm.get('cif')?.touched">
                            <input type="text" class="w-100" placeholder="Ej: B12345678" formControlName="cif">
                        </div>
                        <span class="field-error" *ngIf="companyForm.get('cif')?.invalid && companyForm.get('cif')?.touched">Campo obligatorio</span>
                    </div>
                </div>

                <div class="main-inputs">
                    <div class="field-block">
                        <label class="label-input">País <span class="req">*</span></label>
                        <mat-form-field appearance="fill" class="filter-place"
                            [class.invalid]="companyForm.get('id_country')?.invalid && companyForm.get('id_country')?.touched">
                            <mat-select formControlName="id_country" placeholder="Selecciona un país">
                                <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</mat-option>
                            </mat-select>
                            <mat-select-trigger matSuffix style="vertical-align: middle;"><i class="fal fa-angle-down pointer-in"></i></mat-select-trigger>
                        </mat-form-field>
                        <span class="field-error" *ngIf="companyForm.get('id_country')?.invalid && companyForm.get('id_country')?.touched">Campo obligatorio</span>
                    </div>
                    <div class="field-block">
                        <label class="label-input">Provincia <span class="req">*</span></label>
                        <mat-form-field appearance="fill" class="filter-place"
                            [class.invalid]="companyForm.get('id_state')?.invalid && companyForm.get('id_state')?.touched">
                            <mat-select formControlName="id_state" placeholder="Selecciona una provincia">
                                <mat-option *ngFor="let state of states" [value]="state.id">{{ state.name }}</mat-option>
                            </mat-select>
                            <mat-select-trigger matSuffix style="vertical-align: middle;"><i class="fal fa-angle-down pointer-in"></i></mat-select-trigger>
                        </mat-form-field>
                        <span class="field-error" *ngIf="companyForm.get('id_state')?.invalid && companyForm.get('id_state')?.touched">Campo obligatorio</span>
                    </div>
                </div>

                <div class="main-inputs">
                    <div class="field-block">
                        <label class="label-input">Ciudad <span class="req">*</span></label>
                        <div class="form-input-container" [class.invalid]="companyForm.get('city')?.invalid && companyForm.get('city')?.touched">
                            <input type="text" class="w-100" placeholder="Ej: Madrid" formControlName="city" autocomplete="address-level2">
                        </div>
                        <span class="field-error" *ngIf="companyForm.get('city')?.invalid && companyForm.get('city')?.touched">Campo obligatorio</span>
                    </div>
                    <div class="field-block">
                        <label class="label-input">Dirección <span class="req">*</span></label>
                        <div class="form-input-container" [class.invalid]="companyForm.get('address')?.invalid && companyForm.get('address')?.touched">
                            <input type="text" class="w-100" placeholder="Ej: Calle Mayor 1" formControlName="address" autocomplete="street-address">
                        </div>
                        <span class="field-error" *ngIf="companyForm.get('address')?.invalid && companyForm.get('address')?.touched">Campo obligatorio</span>
                    </div>
                </div>

                <div class="main-inputs">
                    <div class="field-block">
                        <label class="label-input">Código postal <span class="req">*</span></label>
                        <div class="form-input-container" [class.invalid]="companyForm.get('postal_code')?.invalid && companyForm.get('postal_code')?.touched">
                            <input type="number" class="w-100" placeholder="Ej: 28001" formControlName="postal_code" autocomplete="postal-code" (input)="onPostalCodeInput($event)">
                        </div>
                        <span class="field-error" *ngIf="companyForm.get('postal_code')?.invalid && companyForm.get('postal_code')?.touched">Máximo 5 dígitos</span>
                    </div>
                    <div class="field-block">
                        <label class="label-input">IVA <span class="req">*</span></label>
                        <mat-form-field appearance="fill" class="filter-place"
                            [class.invalid]="companyForm.get('taxes')?.invalid && companyForm.get('taxes')?.touched">
                            <mat-select formControlName="taxes" placeholder="Selecciona el tipo de IVA">
                                <mat-option *ngFor="let iva of ivaOptions" [value]="iva.id">{{ iva.name }}</mat-option>
                            </mat-select>
                            <mat-select-trigger matSuffix style="vertical-align: middle;"><i class="fal fa-angle-down pointer-in"></i></mat-select-trigger>
                        </mat-form-field>
                        <span class="field-error" *ngIf="companyForm.get('taxes')?.invalid && companyForm.get('taxes')?.touched">Campo obligatorio</span>
                    </div>
                </div>
            </form>
        </div>

        <!-- STEP 2: Datos Generales -->
        <div *ngIf="currentStep === 2">
            <div *ngIf="showErrorMsg" class="info-error">
                <i class="fa-light fa-circle-exclamation"></i>
                <p class="error-msg">Completa todos los campos obligatorios antes de continuar</p>
            </div>
            <form [formGroup]="companyForm">
                <div class="step2-grid">
                    <div class="step2-fields">
                        <div class="field-block">
                            <label class="label-input">Nombre visible en Citylok <span class="req">*</span></label>
                            <div class="form-input-container" [class.invalid]="companyForm.get('name')?.invalid && companyForm.get('name')?.touched">
                                <input type="text" class="w-100" placeholder="Nombre público de la empresa" formControlName="name">
                            </div>
                            <span class="field-error" *ngIf="companyForm.get('name')?.invalid && companyForm.get('name')?.touched">Campo obligatorio</span>
                        </div>
                        <div class="field-block">
                            <label class="label-input">Descripción <span class="label-optional">(opcional)</span></label>
                            <div class="form-input-container textarea-container">
                                <textarea class="w-100" placeholder="Describe brevemente la empresa..." formControlName="description"></textarea>
                            </div>
                        </div>
                        <div class="field-block">
                            <label class="label-input">Condiciones generales <span class="label-optional">(opcional)</span></label>
                            <div class="form-input-container textarea-container">
                                <textarea class="w-100" placeholder="Condiciones de uso o contratación..." formControlName="general_conditions"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="step2-image">
                        <label class="label-input">Logo</label>
                        <div class="container-image" (click)="file.click()">
                            <div class="not-image-business">
                                <i class="fa-thin fa-image" *ngIf="!companyForm.controls.imgControl.value"></i>
                                <img [src]="companyForm.controls.imgControl.value" alt="Logo empresa" *ngIf="companyForm.controls.imgControl.value" />
                            </div>
                            <input id="file" #file hidden type="file" accept="image/*" (change)="onFileChange($event)">
                            <div class="circle-add-image">
                                <i class="fa-light fa-plus"></i>
                            </div>
                        </div>
                        <p class="image-hint">Haz clic para subir un logo</p>
                    </div>
                </div>
            </form>
        </div>

        <!-- STEP 3: Comisiones -->
        <div *ngIf="currentStep === 3" [formGroup]="companyForm">
            <p class="fee-step-hint">Selecciona el tipo de comisión por defecto para esta empresa.</p>

            <div class="fee-field-group">
                <label class="label-input">Tipo de comisión</label>
                <div class="fee-type-cards">
                    <div class="fee-type-card" *ngFor="let ft of feeTypes"
                        [class.active]="companyForm.get('fee_type').value === ft.id"
                        (click)="companyForm.get('fee_type').setValue(ft.id)">
                        <i class="fal fee-type-icon" [class]="'fal ' + ft.icon"></i>
                        <div class="fee-type-text">
                            <span class="fee-type-label">{{ ft.label }}</span>
                            <span class="fee-type-desc">{{ ft.desc }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Valor: tipo 1 (%) -->
            <div class="fee-field-group" *ngIf="companyForm.get('fee_type').value === 1">
                <label class="label-input">Porcentaje (%) <span class="req">*</span></label>
                <div class="form-input-container fee-value-input" [class.invalid]="companyForm.get('fee_value')?.invalid && companyForm.get('fee_value')?.touched">
                    <input type="number" min="0" max="100" step="0.01" class="w-100"
                        placeholder="Ej: 10" formControlName="fee_value">
                    <span class="fee-unit">%</span>
                </div>
                <span class="fee-vat-hint"><i class="fal fa-info-circle"></i> IVA del 21% incluido</span>
                <span class="field-error" *ngIf="companyForm.get('fee_value')?.invalid && companyForm.get('fee_value')?.touched">Campo obligatorio</span>
            </div>

            <!-- Valor: tipo 2 (fijo) -->
            <div class="fee-field-group" *ngIf="companyForm.get('fee_type').value === 2">
                <label class="label-input">Importe fijo (€) <span class="req">*</span></label>
                <div class="form-input-container fee-value-input" [class.invalid]="companyForm.get('fee_value')?.invalid && companyForm.get('fee_value')?.touched">
                    <input type="number" min="0" step="0.01" class="w-100"
                        placeholder="Ej: 1.50" formControlName="fee_value">
                    <span class="fee-unit">€</span>
                </div>
                <span class="fee-vat-hint"><i class="fal fa-info-circle"></i> IVA del 21% incluido</span>
                <span class="field-error" *ngIf="companyForm.get('fee_value')?.invalid && companyForm.get('fee_value')?.touched">Campo obligatorio</span>
            </div>

            <!-- Valor: tipo 3 (tramos) -->
            <div class="fee-field-group" *ngIf="companyForm.get('fee_type').value === 3">
                <label class="label-input">Comisión por tramos</label>
                <p class="tier-hint">Cada tramo define la comisión que se aplica según el precio del ticket.</p>
                <div class="fee-tiers">
                    <div class="tier-card" *ngFor="let tier of feeTiers; let i = index; let last = last">

                        <!-- Rango visible (autocalculado) -->
                        <div class="tier-range">
                            <span class="tier-range-from">{{ i === 0 ? '0' : feeTiers[i-1].max || '?' }} €</span>
                            <i class="fal fa-long-arrow-right tier-range-arrow"></i>
                            <span class="tier-range-to" *ngIf="!last">{{ tier.max || '?' }} €</span>
                            <span class="tier-range-to tier-range-open" *ngIf="last">∞</span>
                        </div>

                        <!-- Divisor -->
                        <div class="tier-divider"></div>

                        <!-- Inputs -->
                        <div class="tier-inputs">
                            <div class="tier-input-group" *ngIf="!last">
                                <span class="tier-input-label">Precio máximo</span>
                                <div class="form-input-container tier-input-field" [class.invalid]="tierIsInvalid(i)">
                                    <input type="number" min="0" step="0.01" class="w-100"
                                        [(ngModel)]="tier.max" [ngModelOptions]="{standalone: true}"
                                        placeholder="0.00">
                                    <span class="tier-unit">€</span>
                                </div>
                                <span class="tier-error" *ngIf="tierIsInvalid(i)">Debe ser mayor que el tramo anterior</span>
                            </div>
                            <div class="tier-input-group" *ngIf="last">
                                <span class="tier-input-label">Precio máximo</span>
                                <div class="form-input-container tier-input-field tier-input-disabled">
                                    <span class="tier-inf">∞ sin límite</span>
                                </div>
                            </div>
                            <div class="tier-input-group">
                                <span class="tier-input-label">Comisión</span>
                                <div class="form-input-container tier-input-field">
                                    <input type="number" min="0" step="0.01" class="w-100"
                                        [(ngModel)]="tier.value" [ngModelOptions]="{standalone: true}"
                                        placeholder="0.00">
                                    <span class="tier-unit">€</span>
                                </div>
                            </div>
                        </div>

                        <button class="tier-del-btn" (click)="removeTier(i)"
                            [disabled]="feeTiers.length <= 2 || last" title="Eliminar">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <button class="tier-add-btn" (click)="addTier()" [class.disabled]="!tiersAreValid()" [title]="!tiersAreValid() ? 'Corrige los tramos antes de añadir uno nuevo' : ''">
                        <i class="fal fa-plus"></i> Añadir tramo
                    </button>
                </div>
            </div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <div class="footer-new-manager">
        <div *ngIf="currentStep === 1" class="d-flex justify-content-end gap-2 w-100">
            <div class="btn-new btn-create m-0" (click)="nextStep()">
                <p class="m-0">Siguiente <i class="fal fa-arrow-right ms-1"></i></p>
            </div>
        </div>
        <div *ngIf="currentStep === 2" class="d-flex justify-content-between w-100">
            <div class="btn-new btn-create btn-create-border m-0 me-2 btn-back" (click)="previousStep()">
                <p class="m-0"><i class="fal fa-arrow-left me-1"></i> Atrás</p>
            </div>
            <div class="btn-new btn-create m-0" (click)="nextStep()">
                <p class="m-0">Siguiente <i class="fal fa-arrow-right ms-1"></i></p>
            </div>
        </div>
        <div *ngIf="currentStep === 3" class="d-flex justify-content-between w-100">
            <div class="btn-new btn-create btn-create-border m-0 me-2 btn-back" (click)="previousStep()">
                <p class="m-0"><i class="fal fa-arrow-left me-1"></i> Atrás</p>
            </div>
            <div class="btn-new btn-create m-0" (click)="!loading && createCompany()" [class.disabled]="companyForm.invalid || loading">
                <p class="m-0">
                    <i class="fal me-1" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                    {{ loading ? 'Creando...' : 'Crear empresa' }}
                </p>
            </div>
        </div>
    </div>
</div>
